/**
 * 删除对象中的空字符及null
 * @param obj 要处理的对象
 * @param parent
 * @param parentKey
 * @returns {*}
 */
export function removeEmpty(obj, parent, parentKey) {
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object') {
      removeEmpty(obj[key], obj, key)
    }
    if (obj[key] === undefined || obj[key] === null || (obj[key] !== null && obj[key].length === 0) || obj[key] === '') {
      delete obj[key]
    }
  })
  if (Object.keys(obj).length === 0) {
    delete parent[parentKey]
  }
  return obj
}

export function formatNum(str) {
  let newStr = ''
  let count = 0
  // 判断是不是数值
  if (isNaN(str)) {
    // console.error('str is not Number')
    return
  }
  // 首先先将数值根据 ‘.’剪切成一个数组
  const arr = (str + '').split('.')
  // 判断数组的长度最长为2  0.00
  if (arr.length <= 1) {
    // 如果数组长度小于1 则进行拼接千分位逗号拼接小数点后两位
    for (var i = arr[0].length - 1; i >= 0; i--) {
      if (count % 3 === 0 && count !== 0) {
        newStr = arr[0].charAt(i) + ',' + newStr
      } else {
        newStr = arr[0].charAt(i) + newStr
      }
      count++
    }
    str = newStr + '.00' // 自动补小数点后两位
    return str
  } else {
    // 如果数组长度大于1 则先进行拼接千分位逗号再 拼接小数点后两位
    for (let i = arr[0].length - 1; i >= 0; i--) {
      if (count % 3 === 0 && count !== 0) {
        newStr = arr[0].charAt(i) + ',' + newStr
      } else {
        newStr = arr[0].charAt(i) + newStr
      }
      count++
    }
    str = newStr + (str + '00').substr((str + '00').indexOf('.'), 3)
    return str
  }
}

/**
 * 去除首位空格
 * 2019-11-19 16:43:16
 * @param str
 */
export function trim(str) {
  if (!str && str !== 0) return ''
  str += ''
  return str.replace(/(^\s*)|(\s*$)/g, '')
}
/**
 * 去除所有空格
 * 2019-11-19 16:43:16
 * @param str
 */
export function allTrim(str) {
  if (!str && str !== 0) return ''
  str += ''
  return str.replace(/\s*/g, '')
}
/**
 * 只允许输入数字
 * @author 王老玖
 */
export function allowNumber(str) {
  return str.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
}
/**
 * 只允许输入字母
 * @author 王老玖
 */
export function allowLetter(str) {
  return str.replace(/[^a-zA-Z]/g, '')
}

export function clearNoNum(obj) {
  obj.value = obj.value.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
  obj.value = obj.value.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
  obj.value = obj.value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
  obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
  if (obj.value.indexOf('.') < 0 && obj.value !== '') { // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    obj.value = parseFloat(obj.value)
  }
}

/**
 * 禁输表情
 * @param value {String}
 */
export function inputEmoji(value) {
  var regStr
  regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
  if (regStr.test(value)) {
    return value.replace(regStr, '')
  } else {
    return value
  }
}
/**
 * 序号递增函数
 * @author 王老玖
 */
export function indexMet(_Index) {
  if (this.listQuery.current) {
    return (_Index + 1) + (this.listQuery.current - 1) * this.listQuery.size
  } else return (_Index + 1) + (this.listQuery.p - 1) * this.listQuery.n
}

/**
 * 金额转换
 */
export function formatterPrice(cellVal) {
  if (cellVal === null || isNaN(cellVal)) return ''
  return '￥' + formatNum(cellVal)
}

export const formatTime = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

export const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

/**
 * @return {null}
 */
export function GetQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}
/**
 * 节流
 * @param {*} func 执行函数
 * @param {*} delay 节流时间,毫秒
 */
export const throttle = function(func, delay) {
  let timer = null
  return function() {
    if (!timer) {
      timer = setTimeout(() => {
        func.apply(this, arguments)
        // 或者直接 func()
        timer = null
      }, delay)
    }
  }
}

/**
 * 防抖
 * @param {*} fn 执行函数
 * @param {*} wait 防抖时间,毫秒
 */
export const debounce = function(fn, wait) {
  let timeout = null
  return function() {
    if (timeout !== null) clearTimeout(timeout)// 如果多次触发将上次记录延迟清除掉
    timeout = setTimeout(() => {
      fn.apply(this, arguments)
      // 或者直接 fn()
      timeout = null
    }, wait)
  }
}

/**
 *  获取 url 后面通过?传参的参数
 * @param {String} name
 */
export function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const url = window.location.href
  const search = url.substring(url.lastIndexOf('?') + 1)
  const r = search.match(reg)
  if (r != null) return unescape(r[2])
  return null
}

export function onDownFile(url, filename) {
  const downUrl = url
  // 创建隐藏的可下载链接
  const eleLink = document.createElement('a')

  eleLink.download

  eleLink.style.display = 'none'
  // 字符内容转变成blob地址
  const blob = new window.Blob([downUrl])
  eleLink.href = URL.createObjectURL(blob)
  eleLink.target = `_blank`
  // 触发点击
  document.body.appendChild(eleLink)
  eleLink.click()
  // 然后移除
  document.body.removeChild(eleLink)
}

/**
 * 判断两个数组是否相等
 * 2020-5-18 09:39:51
 * @author SnowRock
 * @param array {Array} 数组一
 * @param other {Array} 数组二
 * @returns {boolean}
 */
export function arrayEqual(array, other) {
  const l = array.length
  if (!other) return false
  if (l !== other.length) return false

  for (let i = 0; i < l; i++) {
    if (array[i] instanceof Array && other[i] instanceof Array) {
      if (!array[i].equals(other[i])) return false
    } else if (array[i] !== other[i]) {
      return false
    }
  }
  return true
}
export function roundNumber(number, decimals) {
  var newString// The new rounded number
  decimals = Number(decimals)
  // 如果设置参数为0
  if (decimals === 0) {
    return (Math.round(number)).toString()
  }
  if (decimals < 1) {
    newString = (Math.round(number)).toString()
  } else {
    var numString = number.toString()
    if (numString.lastIndexOf('.') === -1) { // If there is no decimal point
      numString += '.'// give it one at the end
    }
    var cutoff = numString.lastIndexOf('.') + decimals // The point at which to truncate the number
    var d1 = Number(numString.substring(cutoff, cutoff + 1)) // The value of the last decimal place that we'll end up with
    var d2 = Number(numString.substring(cutoff + 1, cutoff + 2)) // The next decimal, after the last one we want
    if (d2 >= 5) { // Do we need to round up at all? If not, the string will just be truncated
      if (d1 === 9 && cutoff > 0) { // If the last digit is 9, find a new cutoff point
        while (cutoff > 0 && (d1 === 9 || isNaN(d1))) {
          if (d1 !== '.') {
            cutoff -= 1
            d1 = Number(numString.substring(cutoff, cutoff + 1))
          } else {
            cutoff -= 1
          }
        }
      }
      d1 += 1
    }
    if (d1 === 10) {
      numString = numString.substring(0, numString.lastIndexOf('.'))
      var roundedNum = Number(numString) + 1
      newString = roundedNum.toString() + '.'
    } else {
      newString = numString.substring(0, cutoff) + d1.toString()
    }
  }
  if (newString.lastIndexOf('.') === -1) { // Do this again, to the new string
    newString += '.'
  }
  var decs = (newString.substring(newString.lastIndexOf('.') + 1)).length
  for (var i = 0; i < decimals - decs; i++) newString += '0'
  return newString
}

/**
 * 数组去重
 * @param arr
 * @returns {any[]}
 */
export function unique(arr) {
  return Array.from(new Set(arr))
}

/**
 * 数组取异
 * @param arr
 * @param arrOther
 * @returns {any[]}
 */
export function uniqueDifferent(arr, arrOther) {
  return arr.filter(v => !arrOther.includes(v))
}

export function randomString(len) {
  len = len || 32
  // ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz
  // var $chars = 'abcdef0123456789';
  var $chars = '0123456789'
  /** 默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1 **/
  var maxPos = $chars.length
  var pwd = []
  for (let i = 0; i < len; i++) {
    pwd[i] = $chars[Math.floor(Math.random() * maxPos)]
  }
  return pwd.join('')
}

export function randomNum(minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10)
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
    default:
      return 0
  }
}

export function randomTimeStr() {
  const timeSign = new Date().getTime()
  const str = randomString(9)
  return 'SERVICE_PLATFORM_MANAGE:' + timeSign + ':' + str
}

export function randomTimeStrByMark() {
  const timeSign = new Date().getTime()
  const str = randomString(8)
  return timeSign + str
}

export function isPrice(value) {
  return /^([0-9]+)$/.test(value)
}

/**
 * 将数字转化为百分格式(保留2位小数点)
 * 2021-05-29 12:36:12
 * @author BM
 */
export function transformPercent(val) {
  if (typeof (val) === 'number') {
    return (val * 100).toFixed(2) + '%'
  }
}
/**
 * 将base64 的图片转换成file对象上传 atob将ascii码解析成binary数据
 * 2022-03-24 12:36:12
 * @author afeng
 */
export function base64ToFile(data) {
  const binary = atob(data.split(',')[1])
  const mime = data.split(',')[0].match(/:(.*?);/)[1]
  const array = []
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i))
  }
  const fileData = new Blob([new Uint8Array(array)], {
    type: mime
  })

  const file = new File([fileData], `${new Date().getTime()}.png`, { type: mime })

  return file
}

export function isAdmin() {
  return sessionStorage.getItem('username') === 'admin'
}

/** 账号授权里的「数据大屏」菜单（名称或路由命中即可） */
export function isScreenMenu(menu) {
  if (!menu || typeof menu !== 'object') return false
  const name = String(menu.name || '')
  const url = String(menu.url || '')
  return url === '/screen' || /数据大屏|智慧养老大屏|智慧养老院|大屏/.test(name)
}

function roleListHasScreen(list, depth) {
  if (list == null || depth > 4) return false
  const arr = Array.isArray(list) ? list : (typeof list === 'object' ? Object.values(list) : [])
  return arr.some(item => {
    if (isScreenMenu(item)) return true
    if (item && item.child) return roleListHasScreen(item.child, depth + 1)
    return false
  })
}

/**
 * 数据大屏可见性：admin 不受限；其他账号须在授权中勾选数据大屏，登录角色里才会带上该菜单。
 */
export function hasScreenPermission(rules) {
  if (isAdmin()) return true
  return roleListHasScreen(getLoginRules(rules), 0)
}

/**
 * 订单列表时间范围搜索：接口传 yyyy-MM-dd,yyyy-MM-dd
 * 兼容选择器返回的日期字符串、时间戳（秒/毫秒）、Date
 */
export function joinDateRange(range) {
  if (!range || !Array.isArray(range) || range.length < 2 || range[0] == null || range[1] == null || range[0] === '' || range[1] === '') {
    return ''
  }
  const toYmd = v => {
    if (typeof v === 'string') {
      const m = v.trim().match(/^(\d{4}-\d{2}-\d{2})/)
      if (m) return m[1]
    }
    const n = Number(v)
    let d
    if (Number.isFinite(n) && n > 1e9) {
      d = new Date(n < 1e12 ? n * 1000 : n)
    } else {
      d = new Date(v)
    }
    if (isNaN(d.getTime())) return ''
    const y = d.getFullYear()
    const m = d.getMonth() + 1
    const day = d.getDate()
    return `${y}-${m < 10 ? '0' : ''}${m}-${day < 10 ? '0' : ''}${day}`
  }
  const start = toYmd(range[0])
  const end = toYmd(range[1])
  return start && end ? `${start},${end}` : ''
}

function parseStoredRoleIds(val) {
  if (val == null || val === '') return []
  let parsed = val
  if (typeof val === 'string') {
    const s = val.trim()
    if (!s) return []
    try {
      parsed = s.startsWith('[') ? JSON.parse(s) : s
    } catch (e) {
      parsed = s
    }
  }
  const arr = Array.isArray(parsed) ? parsed : String(parsed).split(/[,，]/)
  return arr.map(i => String(i).trim()).filter(Boolean)
}

function flattenRoleIds(val, depth) {
  if (val == null || val === '' || depth > 4) return []
  if (Array.isArray(val)) {
    const ids = []
    val.forEach(item => {
      flattenRoleIds(item, (depth || 0) + 1).forEach(id => ids.push(id))
    })
    return ids
  }
  if (typeof val === 'object') {
    if (val.id != null && val.id !== '') return [String(val.id)]
    const ids = []
    Object.values(val).forEach(item => {
      if (item == null || typeof item === 'object') return
      flattenRoleIds(item, (depth || 0) + 1).forEach(id => ids.push(id))
    })
    return ids
  }
  return parseStoredRoleIds(val)
}

/** 登录后把 dis_role / tf_role / cri_role 写入 session，兼容数组、对象、逗号串 */
export function persistSessionRole(key, val) {
  const ids = flattenRoleIds(val)
  if (!ids.length) {
    sessionStorage.removeItem(key)
    return
  }
  sessionStorage.setItem(key, ids.join(','))
}

function getLoginRules(rules) {
  if (Array.isArray(rules) && rules.length) return rules
  try {
    const raw = sessionStorage.getItem('role')
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (Array.isArray(parsed)) return parsed
    if (parsed && typeof parsed === 'object') return Object.values(parsed)
  } catch (e) {
    return []
  }
  return []
}

function findMenuByMatchers(rules, matchers) {
  const list = getLoginRules(rules)
  for (let i = 0; i < matchers.length; i++) {
    const found = list.find(matchers[i])
    if (found) return found
  }
  return null
}

function menuChildren(menu) {
  if (!menu || menu.child == null) return []
  return Object.values(menu.child).filter(Boolean)
}

function collectChildRoleIds(menu, sessionKey) {
  const ids = new Set()
  menuChildren(menu).forEach(m => {
    if (m && m.id != null && m.id !== '') ids.add(String(m.id))
  })
  parseStoredRoleIds(sessionStorage.getItem(sessionKey)).forEach(id => ids.add(id))
  return Array.from(ids)
}

function childHasAssignNurse(menu, assignIds) {
  return menuChildren(menu).some(m => {
    const id = m && m.id != null ? String(m.id) : (typeof m === 'string' || typeof m === 'number' ? String(m) : '')
    const name = m && m.name ? String(m.name) : ''
    return assignIds.indexOf(id) > -1 || /指派|改派/.test(name)
  })
}

/** 登录后把各模块子权限写入 session，并合并 role 菜单上已带的 child */
export function persistLoginModuleRoles(roleList, data) {
  persistSessionRole('dis_role', data && data.dis_role)
  persistSessionRole('tf_role', data && data.tf_role)
  persistSessionRole('cri_role', data && data.cri_role)
  const mergeMenuChild = (key, menu) => {
    const extra = menuChildren(menu)
      .map(m => (m && m.id != null && m.id !== '' ? String(m.id) : ''))
      .filter(Boolean)
    if (!extra.length) return
    const existing = parseStoredRoleIds(sessionStorage.getItem(key))
    persistSessionRole(key, existing.concat(extra))
  }
  mergeMenuChild('dis_role', findSnMenu(roleList))
  mergeMenuChild('tf_role', findTfMenu(roleList))
  mergeMenuChild('cri_role', findBoardingMenu(roleList))
}

function findSnMenu(rules) {
  return findMenuByMatchers(rules, [
    i => i && Number(i.id) === 15,
    i => i && i.url === '/orders_sn',
    i => i && i.name && /居家养老|失能人员/.test(String(i.name))
  ])
}

function findTfMenu(rules) {
  return findMenuByMatchers(rules, [
    i => i && Number(i.id) === 16,
    i => i && i.url === '/orders_tf',
    i => i && i.name && /探访关爱|特困/.test(String(i.name))
  ])
}

function findBoardingMenu(rules) {
  return findMenuByMatchers(rules, [
    i => i && (i.url === '/orders_boarding' || (i.name && String(i.name).indexOf('残疾人寄宿托养') > -1)),
    i => i && i.name && String(i.name).indexOf('寄宿托养') > -1,
    i => i && Number(i.id) === 17
  ])
}

/** 居家养老上门护理：登录角色里该菜单的子权限 id 列表（含 session dis_role） */
export function getSnChildRoleIds(rules) {
  return collectChildRoleIds(findSnMenu(rules), 'dis_role')
}

/** 特困老人探访关爱：登录角色里该菜单的子权限 id 列表（含 session tf_role） */
export function getTfChildRoleIds(rules) {
  return collectChildRoleIds(findTfMenu(rules), 'tf_role')
}

/** 残疾人寄宿托养服务：登录角色里该菜单的子权限 id 列表 */
export function getBoardingChildRoleIds(rules) {
  return collectChildRoleIds(findBoardingMenu(rules), 'cri_role')
}

const ASSIGN_ROLE_IDS = ['1', '7', '8']

function hasAssignByIds(ids) {
  return (ids || []).some(id => ASSIGN_ROLE_IDS.indexOf(String(id)) > -1)
}

/**
 * 居家养老「指/改派护工」：
 * 登录 role 往往只有父级、不带子权限。有居家养老菜单即显示（与寄宿托养一致）。
 */
export function hasSnAssignNurse(rules) {
  if (findSnMenu(rules)) return true
  const ids = getSnChildRoleIds(rules)
  if (hasAssignByIds(ids)) return true
  return childHasAssignNurse(findSnMenu(rules), ASSIGN_ROLE_IDS)
}

/**
 * 探访关爱「指/改派护工」：
 * 授权项名称是「指派订单」，id 不一定是 7。
 * 登录 role 往往只有父级菜单、不带 tf_role 子节点，有探访关爱菜单即显示。
 */
export function hasTfAssignNurse(rules) {
  if (findTfMenu(rules)) return true
  const ids = getTfChildRoleIds(rules)
  if (hasAssignByIds(ids)) return true
  return childHasAssignNurse(findTfMenu(rules), ASSIGN_ROLE_IDS)
}

/**
 * 寄宿托养详情「指/改派护工」：
 * 授权存在 cri_role（本模块为 1），登录 role 往往只有父级菜单、不带子权限。
 * 有寄宿托养菜单即显示按钮。
 */
export function hasBoardingAssignNurse(rules) {
  if (findBoardingMenu(rules)) return true
  const ids = getBoardingChildRoleIds(rules)
  if (hasAssignByIds(ids)) return true
  return childHasAssignNurse(findBoardingMenu(rules), ASSIGN_ROLE_IDS)
}
